import { FC, useEffect } from "react";
import "./styles.scss";
import { TextArea as CarbonTextArea } from "carbon-components-react";

interface TextAreaProps {
  label: string;
  name: string;
  control: any;
  Controller: any;
  setValue?: Function;
  watch?: Function;
  error?: string;
  size?: string;
  placeholderText?: string;
  helperText?: string;
  disabled?: boolean;
  toggleValue?: boolean;
  QuestionTooltip?: any;
  resetField?: any;
  defaultValue?: string;
}

const TextArea: FC<TextAreaProps> = (props) => {
  const {
    name,
    label,
    error,
    disabled,
    control,
    Controller,
    setValue = () => {},
    watch = () => {},
    toggleValue,
    placeholderText,
    helperText = false,
    size = "large",
    QuestionTooltip,
    resetField,
    defaultValue,
  } = props;

  const fieldToWatch = watch(name);

  useEffect(() => {
    if (toggleValue) {
      setValue(name, "unknown", { shouldValidate: true });
    } else if (!toggleValue && resetField) {
      resetField(name);
      setValue(name, "");
    } else if (!toggleValue) {
      setValue(name, "");
    }
  }, [toggleValue]);

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue, {
        shouldValidate: true,
      });
    }
  }, []);

  return (
    <div className={size}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, onBlur } }) => (
          <CarbonTextArea
            id={name}
            labelText={
              <>
                {label}
                {QuestionTooltip}
              </>
            }
            value={fieldToWatch}
            placeholder={fieldToWatch || placeholderText}
            helperText={helperText}
            disabled={disabled || toggleValue}
            invalid={!!error}
            invalidText={error}
            onChange={(value) => {
              onChange(value);
            }}
            onBlur={onBlur}
            defaultValue={defaultValue}
          />
        )}
      />
    </div>
  );
};

export default TextArea;
